import useApp from "../../../lib/providers/appProvider";
import React, { useEffect, useState } from "react";
import useGlobalProvider from "../../../lib/providers/globalProvider";
import WarningBanner from "../../../components/WarningBanner";
import { useLocation, useNavigate } from "react-router-dom";
import useNavigation from "../../../lib/providers/navigationProvider";
import { EuiButton, EuiHorizontalRule, EuiSpacer, EuiText } from "@elastic/eui";
import LoculiTable from "../../../components/table/pageTables/Loculi.table";
import LoculiToolbar from "../../../components/searchToolbar/pageToolbars/Loculi.toolbar";
import { useCimiteri } from "../../../lib/hooks/api/cimiteri";
import useAuth from "../../../lib/providers/authProvider";
import { isSuperAdmin } from "../../../lib/auth";
import TableError from "../../../components/errors/TableError";
import ErrorBoundaryInternal from "../../../lib/ErrorService/ErrorBoundaryInternal";

function LoculiPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { setPageHeaderActions } = useNavigation();
  const { setManualPageTitle } = useApp();
  const { currentComuneId, globalWarning } = useGlobalProvider();
  const [tableQuery, setTableQuery] = useState(
    location.state?.query ? location.state.query : {}
  );
  const [noCimiteriWarning, setNoCimiteriWarning] = useState(null);
  const {
    cimiteri,
    isLoading: isCimiteriLoading,
    isFetching: isCimiteriFetching,
  } = useCimiteri(
    currentComuneId,
    {
      query: {},
      sort: {},
      populate: [],
    },
    true
  );

  useEffect(() => {
    setManualPageTitle("Loculi");
  }, []);

  const newButton = (
    <EuiButton size="s" fill onClick={() => navigate("/loculi/nuovo")}>
      Crea nuovo
    </EuiButton>
  );

  useEffect(() => {
    if (globalWarning || noCimiteriWarning) {
      setPageHeaderActions([]);
    } else {
      setPageHeaderActions([newButton]);
    }
    return () => setPageHeaderActions([]);
  }, [globalWarning, noCimiteriWarning]);

  useEffect(() => {
    if (
      cimiteri.data.length === 0 &&
      !isCimiteriFetching &&
      !isCimiteriLoading
    ) {
      let body;
      let actions;
      if (isSuperAdmin(user)) {
        body = (
          <EuiText>
            <p>Prima di procedere è necessario creare un cimitero.</p>
          </EuiText>
        );
        actions = (
          <EuiButton
            color={"warning"}
            fill
            size="s"
            onClick={() => navigate("/cimitero/nuovo")}
          >
            Inserisci un cimitero
          </EuiButton>
        );
      } else {
        body = (
          <EuiText>
            <div>Prima di procedere è necessario creare un cimitero.</div>
            <EuiSpacer size="s" />
            <div>Chiedi all'admin del gestionale di inserirne</div>
          </EuiText>
        );
      }
      setNoCimiteriWarning({
        title: "Nessun cimitero presente",
        body,
        actions,
      });
    } else {
      setNoCimiteriWarning(null);
    }
  }, [cimiteri, isCimiteriFetching, isCimiteriLoading]);

  if (globalWarning) {
    return (
      <WarningBanner
        title={globalWarning.title}
        body={globalWarning.body}
        actions={globalWarning.actions}
      />
    );
  }

  if (noCimiteriWarning) {
    return (
      <WarningBanner
        title={noCimiteriWarning.title}
        body={noCimiteriWarning.body}
        actions={noCimiteriWarning.actions}
      />
    );
  }

  return (
    <>
      <LoculiToolbar tableQuery={tableQuery} setTableQuery={setTableQuery} />
      <EuiHorizontalRule margin="l" />
      <ErrorBoundaryInternal fallback={TableError}>
        <LoculiTable tableQuery={tableQuery} />
      </ErrorBoundaryInternal>
    </>
  );
}

export default LoculiPage;
